import { render, staticRenderFns } from "./CPDateInput.vue?vue&type=template&id=04248151&scoped=true"
import script from "./CPDateInput.vue?vue&type=script&lang=js"
export * from "./CPDateInput.vue?vue&type=script&lang=js"
import style0 from "./CPDateInput.vue?vue&type=style&index=0&id=04248151&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04248151",
  null
  
)

export default component.exports